<template>
  <a
    :href="formLink()"
    target="_blank"
    class="btn btn-warning btn-sm"
  >
    {{ linkMessage }}
  </a>
</template>

<script>
export default {
  name: 'OpenOnSiteButton',
  props: {
    sourceRoute: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    linkMessage: 'Open on site',
  }),
  methods: {
    formLink() {
      let itemRoute = this.sourceRoute || '';
      if (itemRoute[0] === '/') {
        itemRoute = itemRoute.substring(1);
      }
      return `${this.$config.app_api.host}${itemRoute}`;
    },
  },
};
</script>



// WEBPACK FOOTER //
// OpenOnSiteButton.vue?3dff5f4e